<template lang="html">
  <div>
    <div class="graph-title">{{ title }}</div>

    <pie-chart v-if="chartData" :chart-data="chartData" />
  </div>
</template>

<script>
import PieChart from "@/components/PieChart.js";
export default {
  props: {
    title: String,
    data: Array,
    labels: Array,
    colors: Array
  },
  components: {
    PieChart
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.colors,
            data: this.data
          }
        ]
      };
    }
  }
};
</script>

<style lang="css" scoped>
.graph-title {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
